import { Image } from 'antd'
import React from 'react'
import { useWindowSize } from 'src/app/hooks'
import styles from './OrderItemImage.module.scss'

const OrderItemImage: React.FC<{ image: string }> = ({ image }) => {
  const { isMobile } = useWindowSize()
  return <div className={styles.content}>
    <Image
      width={isMobile ? 321 : 400}
      height={321}
      alt='project-image'
      className={styles.image}
      src={image}
      preview={{
        src: image,
      }}
    />
  </div>
}

export default OrderItemImage
